var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { cPointAtOrigin, classNames } from '@shapeable/utils';
var cls = classNames('chart-ring');
import { animated, useSpring } from '@react-spring/web';
import { get } from 'lodash';
import { useThemeEval } from '@shapeable/ui';
export var ChartRingDefaultProps = {
  color: '#FFFFFF33',
  dotRadius: 2,
  index: 0,
  showDots: true,
  initialAngle: 0,
  ringWidth: 1,
  springConfig: {
    duration: 600
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var RingStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DotStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.g(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Ring: styled(animated.circle)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), RingStyles),
  Dot: styled(animated.circle)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), DotStyles)
};
export var ChartRing = function (props) {
  var className = props.className,
    animate = props.animate,
    showDots = props.showDots,
    cx = props.cx,
    cy = props.cy,
    dotCount = props.dotCount,
    radius = props.radius,
    ringWidth = props.ringWidth,
    initialAngle = props.initialAngle,
    springConfig = props.springConfig;
  var dotGap = dotCount && 360 / props.dotCount;
  var $ = useThemeEval();
  var cPoint = cPointAtOrigin(cx, cy);
  var color = $(theme.COLOR(props.color));
  var ringColor = props.ringColor && $(theme.COLOR(props.ringColor)) || color;
  var dotColor = props.ringColor && $(theme.COLOR(props.ringColor)) || color;
  var duration = get(springConfig, 'duration', 600);
  var isAnimated = animate && !!duration;
  var toValues = {
    radius: radius,
    opacity: 1
  };
  var values = isAnimated ? useSpring({
    from: {
      radius: 0,
      opacity: 0
    },
    to: toValues,
    config: springConfig
  }) : toValues;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Ring, {
    fill: "none",
    cx: cx,
    cy: cy,
    r: values.radius,
    style: {
      opacity: values.opacity
    },
    strokeWidth: ringWidth,
    stroke: ringColor
  }), showDots && dotCount && Array.from({
    length: dotCount
  }).map(function (_, i) {
    var point = cPoint(radius, initialAngle + i * dotGap);
    return React.createElement(My.Dot, {
      key: i,
      cx: point.cx,
      style: {
        opacity: values.opacity
      },
      cy: point.cy,
      r: props.dotRadius,
      fill: dotColor
    });
  }));
};
ChartRing.cls = cls;
ChartRing.defaultProps = ChartRingDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;